'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceSetupPrepare = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prefer-stateless-function */
var DeviceSetupPrepare = exports.DeviceSetupPrepare = function DeviceSetupPrepare(_ref) {
  var connectBluetoothDevice = _ref.connectBluetoothDevice,
      handleStandardPlay = _ref.handleStandardPlay;
  return _react2.default.createElement(
    'div',
    { className: 'modal__device-setup__welcome' },
    _react2.default.createElement(
      'div',
      { className: 'modal__device-setup__top' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'device.puton-header',
        defaultMessage: 'Put on your heart rate monitor',
        tagName: 'h3'
      }),
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'device.place-header',
        defaultMessage: 'Place the Wahoo TICKR directly on skin below your chest, or underneath your sports bra band.',
        tagName: 'p'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal__device-setup__content' },
      _react2.default.createElement('img', { src: require('../../../static/img/setup-monitor.svg'), alt: 'Welcome', className: 'modal__device-setup__device-img' }),
      _react2.default.createElement(
        'button',
        {
          className: 'bt bt--primary bt--width-md mv+',
          onClick: function onClick() {
            return connectBluetoothDevice();
          },
          key: 'device.connect.button'
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'modal.next',
          defaultMessage: 'Next'
        })
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'device.footer',
          defaultMessage: 'Don\'t have a heart rate monitor?',
          tagName: 'span'
        }),
        _react2.default.createElement(
          _reactRouter.Link,
          { onClick: function onClick() {
              return handleStandardPlay();
            }, className: 'ml-' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.video-only',
            defaultMessage: 'Watch video only',
            tagName: 'span'
          })
        )
      )
    )
  );
};

DeviceSetupPrepare.propTypes = {
  connectBluetoothDevice: _propTypes2.default.func,
  handleStandardPlay: _propTypes2.default.func
};